import { Injectable } from '@angular/core';

/***
 * Sense paraules, representa la versió actual de l'aplicació
 */
@Injectable({
    providedIn: 'root'
})
export class VersionService {
    //primer codi --> nous plugins = actualització app store
    //segon codi --> canvis d'endpoints/opcions que afecten a mobile = actualitzacio de ionic
    //hardman.app.version
    //A
    public static readonly version: string = '7.1.2026.04.09.08.00';

    public getVersion(): string {
        return VersionService.version;
    }
}
